/* PMSTEEL · inline video — one accessible click-to-play helper for every inline iframe. */
(function () {
  function stopPlayer(player) {
    if (!player) return;
    var wrap = player.closest('[data-pmsteel-video]');
    var trigger = wrap && wrap.querySelector('[data-pmsteel-video-trigger]');
    var iframe = player.querySelector('iframe');
    if (iframe) iframe.setAttribute('src', '');
    player.remove();
    if (trigger) {
      trigger.hidden = false;
      trigger.focus();
    }
  }

  document.addEventListener('click', function (e) {
    var stop = e.target.closest('[data-pmsteel-video-stop]');
    if (stop) {
      stopPlayer(stop.closest('[data-pmsteel-video-player]'));
      return;
    }

    var btn = e.target.closest('[data-pmsteel-video-trigger]');
    if (!btn) return;
    var wrap = btn.closest('[data-pmsteel-video]');
    if (!wrap) return;
    var embed = wrap.getAttribute('data-embed');
    if (!embed) return;
    var title = wrap.getAttribute('data-title') || 'Video';
    var player = document.createElement('div');
    player.className = 'pmsteel-video__player';
    player.setAttribute('data-pmsteel-video-player', '');
    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', embed);
    iframe.setAttribute('title', title);
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('tabindex', '0');
    iframe.className = wrap.getAttribute('data-frame-class') || 'pmsteel-vid__iframe';
    var stopButton = document.createElement('button');
    stopButton.type = 'button';
    stopButton.className = 'pmsteel-video__stop';
    stopButton.setAttribute('data-pmsteel-video-stop', '');
    stopButton.setAttribute('aria-label', 'Stop video: ' + title);
    stopButton.textContent = 'Stop video';
    btn.hidden = true;
    player.appendChild(iframe);
    player.appendChild(stopButton);
    wrap.appendChild(player);
    iframe.addEventListener('load', function () { iframe.focus(); }, { once: true });
    iframe.focus();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var player = e.target.closest && e.target.closest('[data-pmsteel-video-player]');
    if (player) stopPlayer(player);
  });
})();
